import React from "react";
import { Link } from "react-router-dom";
import { HeartPulse, CheckCircle2, ArrowRight } from "lucide-react";
import PageTitle from "../components/PageTitle";
import { aboutFull, aboutShort } from "../data/mock";

export default function About() {
  return (
    <div>
      <PageTitle title="About Dr. Mamtesh Gupta" crumbs={[{ label: "About Us" }]} />
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <img src={aboutShort.image} alt="Dr. Mamtesh Gupta" className="w-full h-[520px] object-cover rounded-2xl shadow-xl" />
          </div>
          <div>
            <p className="font-script text-emerald-700 text-2xl mb-2">About Dr. Mamtesh Gupta</p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">{aboutFull.heading}</h2>
            <div className="flex items-center gap-2 mb-5">
              <span className="h-[3px] w-10 bg-amber-400"></span>
              <HeartPulse className="w-5 h-5 text-[#b81d24]" />
              <span className="h-[3px] w-10 bg-amber-400"></span>
            </div>
            {aboutFull.paragraphs.map((p, i) => (
              <p key={i} className="text-gray-600 leading-relaxed mb-4">{p}</p>
            ))}
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[#b81d24] hover:bg-[#9a1820] text-white font-bold px-6 py-3 rounded-full transition-colors mt-2">
              Contact Us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-[#fbf6ee] rounded-2xl p-8 border-l-4 border-[#b81d24]">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-[#b81d24] text-white flex items-center justify-center">
                <CheckCircle2 className="w-5 h-5" />
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900">Our Mission</h3>
            </div>
            <p className="text-gray-700 leading-relaxed">{aboutFull.mission}</p>
          </div>
          <div className="bg-[#fbf6ee] rounded-2xl p-8 border-l-4 border-amber-400">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-amber-400 text-[#1a1a1a] flex items-center justify-center">
                <HeartPulse className="w-5 h-5" />
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900">Our Vision</h3>
            </div>
            <p className="text-gray-700 leading-relaxed">{aboutFull.vision}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
